import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

export interface EventLogPayload {
  _id?: string;
  user_id?: string;
  additional_details?: {
    email?: string;
  };
  event_type?: string;
  request_url?: string;
  originating_ip?: string;
  user_agent?: string;
  source?: string;
  source_type?: string;
  status?: 'SUCCESS' | 'FAILURE';
  message?: string;
  created_date?: string;
  __v?: number;
}

class EventLog {
  static ENDPOINT = 'api/v2/event-logs';

  static async getEventLogs(params: any): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(`${this.ENDPOINT}`, params);

      return response;
    } catch (error) {
      throw error;
    }
  }

  static async addEventLog(payload: EventLogPayload): Promise<APIResponseType> {
    try {
      const response = await apiService.post<APIResponseType>(`${this.ENDPOINT}`, payload);

      // Invalidate cache AFTER successful response
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');

      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteEventLog(userId: string): Promise<APIResponseType> {
    if (!userId) throw new Error("EventLog ID is required for deletion");
    try {
      const response = await apiService.delete<APIResponseType>(`${this.ENDPOINT}/${userId}`);

      // Invalidate cache AFTER successful response
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');

      return response;
    } catch (error) {
      throw error;
    }
  }

  static async editEventLog(userId: string, payload: Partial<EventLogPayload>): Promise<APIResponseType> {
    if (!userId) throw new Error("EventLog ID is required for editing");
    if (!Object.keys(payload).length) throw new Error("Edit payload cannot be empty");

    try {
      const response = await apiService.put<APIResponseType>(`${this.ENDPOINT}/${userId}`, payload);

      // Invalidate cache AFTER successful response
      await apiService.invalidateCacheByPrefix(`${this.ENDPOINT}`, 'GET');

      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default EventLog;
